<template>
  <v-layout>
    <v-combobox
      multiple
      class="combobox-drop-down-container"
      v-bind="$attrs"
      v-on="$listeners"
      :items="items"
      :class="{
        required: isRequired,
        'select-drop-down': true,
        'custom-selection': !!$scopedSlots.selection,
        'has-value': !!$attrs.value
      }"
      :menuProps="menuProps"
      item-color="rgb(84, 210, 140)"
      :style="{color: `${brandBgColor} !important`}">
    </v-combobox>
   </v-layout>
</template>

<script>
import ClickOutside from 'vue-click-outside'
export default {
    name: "VcitaCombobox",
    props: {
      items: {
        type: Array,
        required: true,
      }
    },
    directives: {
      ClickOutside
    },
    computed: {
      isRequired() {
        return [false, undefined].indexOf(this.$attrs.required) === -1
      },
      brandBgColor() {
        return this.$store && this.$store.getters['brandModule/secondaryColor'];
      },
      menuProps() {
        let contentClass = 'vcita-combobox-menu'
        if(this.$attrs['menu-props']) {
          if(this.$attrs['menu-props'].contentClass) {
            contentClass += this.$attrs['menu-props'].contentClass
          }
        }
        return {
          ...this.$attrs['menu-props'],
          'close-on-click': true,
          contentClass,
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .combobox-drop-down-container {
    position: relative;
    font-family: var(--primary-font-family);
    border-radius: 6px;
    &.error--text {
      ::v-deep {
        .v-input__slot {
          border: 1px solid #F2514A;
        }
      }
    }
    ::v-deep.v-text-field__details{
      display: none;
    }
    ::v-deep.v-input__slot {
      margin-bottom: 0px;
    }
    ::v-deep.v-label--active{
      font-size: 14px;
    }
    ::v-deep.v-select__selections{
      max-width: 90%;
      flex-wrap: nowrap;
    }
  }


</style>

<style lang="scss">
  .vcita-combobox-menu{
    border-radius: 5px !important;
    .v-list-item__action{
        margin: 1px 2px 1px 1px !important;
    }
    .v-list-item{
      min-height: 37px !important;
    }
    .theme--light.v-list-item--active:hover::before, .theme--light.v-list-item--active::before{
      opacity: 0;
    }
    .v-icon{
      font-size: 20px !important;
    }
    .v-list-item__title{
      font-size: 13px;
      color: black;
      font-family: var(--primary-font-family);
      font-weight: 500;
    }
    .v-subheader{
      color: rgba(0, 0, 0, 0.54);
      font-family: var(--primary-font-family);
      font-weight: 600;
      font-size: 11px;
      height: 32px;
      & ~ .v-subheader{
        border-top-style: solid;
        border-top-width: 1px;
        border-top-color: rgba(0, 0, 0, 0.12);
        padding-top: 6px;
        margin-top: 6px;
      }
    }
  }

</style>
